module.exports = new __parcel__URL__("generic-error-darkmode.3646797f.svg").toString();